import * as types from '@/store/types';

export default {
  [types.GETTER_IS_AUTHENTICATED]: state => state.isAuthenticated,
  [types.GETTER_EXPIRES_IN]: state => state.expiresIn,
  [types.GETTER_AUTH_LOADING]: state => state.loading,
  [types.GETTER_TOKEN]: state => state.token,
  [types.GETTER_KEY]: state => state.key,
};
